module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_all-91df12e831b170bc5f690325e9bd470e.svg";